import { useMutation } from '@tanstack/react-query';
import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/useBoundStore';
import { updateCustomerDataFromServer } from '@Services/init/util.ts';
import { useNavigationManager } from '@Router/useNavigationManager';
import { RoutesMap } from '@Router/router.types';
import { identifyLogRocketUser } from '@Services/analytics/logrocket.service';
import { OnboardingFlowIdentifier } from '@Types/onboarding.types.ts';
import { identifyGA4User, setGA4UserProperties } from '@Services/analytics/analytics.service';

const useGetStartData = () => {
  const { multiBusinessId } = useBoundStore.getState().onboardingSlice;
  const { customerId: customerIdFromResetPasswordStore } =
    useBoundStore.getState().resetPasswordSlice;
  const { customerId: customerIdFromCustomerStore } = useBoundStore.getState().customer;

  const id = multiBusinessId || customerIdFromResetPasswordStore || customerIdFromCustomerStore;
  return useMutation({
    mutationFn: async () => {
      const res = await HttpService.put(`v3/secureonboarding/user/${id}/business/start`);
      return res.data;
    },
  });
};

export const useMultiBusinessIntroLogic = () => {
  const { mutateAsync: asyncGetStartData, isPending } = useGetStartData();
  const { getCustomerData } = useBoundStore.getState();
  const { navigateToNextPage } = useNavigationManager();

  const initStartData = async () => {
    const startData = await asyncGetStartData();
    const dataToUpdate = getCustomerData();
    dataToUpdate.customerId = startData.externalId;
    updateCustomerDataFromServer(startData, dataToUpdate);
    useBoundStore
      .getState()
      .onboardingSlice.setOnboardingIdentifier(OnboardingFlowIdentifier.DIRECT_MULTI_BUSINESS);
    identifyGA4User(startData.externalId);
    setGA4UserProperties();
    identifyLogRocketUser(startData.externalId, {
      isMultiBusiness: true,
    });
    navigateToNextPage(RoutesMap.MULTI_BUSINESS_ONBOARDING_INTRO);
  };

  return { asyncGetStartData: initStartData, isPending };
};
